var _circle, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2301_14283)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2301_14283",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2301_14283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2301_14283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.397 16.4258H11.5V19.3938H16.397V16.4258Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.084 19.3945H15.897V22.3625H20.084V19.3945Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.103 22.3223H20V25.2913H24.103V22.3223Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.206 25.291H24.103V28.26H28.206V25.291Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.609 11H15.187V13.667H16.609V11Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.814 11H23.392V13.667H24.814V11Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.6758V14.2308H12V12.6758H28ZM29 11.6758H11V15.2308H29V11.6758Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 15.791H13C11.896 15.791 11 16.621 11 17.645V27.145C11 28.17 11.896 29 13 29H15.397V29.006H16.397V29H19.5V29.006H20.5V29H23.603V29.006H24.603V29H27C28.104 29 29 28.17 29 27.146V17.646C29 16.621 28.104 15.791 27 15.791ZM28 17.645V24.791H24.603V16.791H27C27.552 16.791 28 17.174 28 17.645ZM16.397 19.894H19.5V21.862H16.397V19.894ZM16.397 18.894V16.791H19.5V18.894H16.397ZM20.5 22.862H23.603V24.791H20.5V22.862ZM20.5 21.862V16.791H23.603V21.862H20.5ZM13 16.791H15.397V18.894H12V17.645C12 17.174 12.449 16.791 13 16.791ZM13 28C12.449 28 12 27.616 12 27.146V19.895H15.397V28H13ZM16.397 28V22.862H19.5V28H16.397ZM20.5 28V25.791H23.603V28H20.5ZM27 28H24.603V25.791H28V27.145C28 27.616 27.552 28 27 28Z",
    fill: "#44A6E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2301_14283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2301_14283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule-icon.1e3e6b4b5154835d7da1aafd8bb9ceb7.svg";
export { ForwardRef as ReactComponent };